export default __webpack_public_path__ + "static/media/img-0226-netherlands-full-face.bee413c0.png";